import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const TITLE_MAP = {
    '/login': 'Login',
    '/onboard': 'Onboarding',
    '/superadmin/login': 'Super Admin Login',
    '/setup': 'Setup Wizard',
    '/superadmin/companies': 'Companies',
    '/superadmin/settings': 'System Settings',
    '/superadmin/pt-settings': 'Professional Tax Slabs',
    '/dashboard': 'Dashboard',
    '/employees': 'Employees',
    '/leave': 'Leave Management',
    '/holidays': 'Holidays',
    '/attendance': 'Attendance',
    '/salary-structure': 'Salary Structure',
    '/salary-advances': 'Salary Advances',
    '/payroll': 'Payroll',
    '/performance': 'Performance',
    '/tax-management': 'Tax Management',
    '/users-roles': 'Users & Roles',
    '/settings': 'Settings',
    '/my-profile': 'My Profile',
    '/my-leaves': 'My Leaves',
    '/my-holidays': 'My Holidays',
    '/my-attendance': 'My Attendance',
    '/my-payslips': 'My Payslips',
    '/my-goals': 'My Goals',
    '/my-tax': 'My Tax Declaration',
    '/tax-certificates': 'Tax Certificates',
    '/directory': 'Employee Directory',
    '/onboarding': 'Onboarding Management',
    '/feeds': 'Feeds',
    '/my-assets': 'My Assets',
    '/assets': 'IT Asset Management',
};

const PageTitle = () => {
    const location = useLocation();

    useEffect(() => {
        const path = location.pathname;
        let pageTitle = TITLE_MAP[path];

        if (!pageTitle) {
            if (path.startsWith('/superadmin/company/')) {
                pageTitle = 'Company Detail';
            } else if (path.startsWith('/employees/')) {
                pageTitle = 'Employee Detail';
            } else {
                pageTitle = 'HRMS';
            }
        }

        document.title = `Teamly - ${pageTitle}`;
    }, [location]);

    return null;
};

export default PageTitle;
